const PHONE_HREF = 'tel:+905362771709';
const WA_HREF = 'https://wa.me/905362771709';

export default function SeoArticle() {
  return (
    <section className="py-24 bg-[#FAF7F2]" aria-label="Alaçatı Tenteci Hakkında Bilgi">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">

          {/* Main Article */}
          <article className="lg:col-span-2 prose-custom">

            {/* ── BÖLÜM 1 ── */}
            <div className="mb-14">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-8 h-px bg-[#D4A853]"></span>
                <span className="text-[#D4A853] text-xs font-bold tracking-widest uppercase">Hizmet Rehberi</span>
              </div>
              <h2 className="text-3xl font-black text-[#111827] mb-8 leading-tight">
                Alaçatı Tenteci Hizmetleri
              </h2>

              <div className="space-y-8">
                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Şık ve Fonksiyonel Çözümler</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    <strong>Alaçatı Tenteci</strong> olarak sunduğumuz tente ve pergola sistemleri, yalnızca güneş koruması sağlamakla kalmaz; açık alanlarınızı dört mevsim kullanılabilir yaşam alanlarına dönüştürür. Kasetli tente, körüklü tente, mafsallı tente, T model tente ve win tente gibi farklı sistemler arasından mekânınıza en uygun olanı seçmenize yardımcı oluyoruz. Her sistem, Alaçatı&apos;nın Ege iklimine ve meltem rüzgarına göre özel olarak değerlendirilir.
                  </p>
                </div>

                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Kalite ve Uygulama Standartları</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Kullandığımız alüminyum profiller ve kumaş malzemeler, tuz havasına, UV ışınlarına ve yüksek rüzgar hızlarına karşı dayanıklı olacak şekilde seçilmektedir. Bioklimatik pergola, otomatik pergola ve rollingroof pergola sistemlerimiz, uluslararası kalite standartlarını karşılayan bileşenlerden üretilmektedir. Montaj sürecinde her detay titizlikle kontrol edilir; işçilik garantisi tüm projelerimizde geçerlidir.
                  </p>
                </div>

                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Kullanım Alanına Göre Seçim</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Villa ve konut terasları için kasetli tente veya bioklimatik pergola öne çıkarken, kafe ve restoran bahçeleri için şeffaf branda, zip perde veya rollingroof pergola daha işlevsel bir çözüm sunar. Ticari cepheler için T model tente, balkon ve pencere üstleri için ise win tente ya da şeffaf stor branda tercih edilmektedir. Ücretsiz keşif hizmetimizle mekânınıza en uygun sistemi birlikte belirleyebiliriz.
                  </p>
                </div>
              </div>
            </div>

            {/* ── BÖLÜM 2 ── */}
            <div className="mb-14">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-8 h-px bg-[#D4A853]"></span>
                <span className="text-[#D4A853] text-xs font-bold tracking-widest uppercase">Güven &amp; Referans</span>
              </div>
              <h2 className="text-3xl font-black text-[#111827] mb-8 leading-tight">
                Alaçatı Tenteci Güvenilir Mi?
              </h2>

              <div className="space-y-8">
                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Deneyim ve Kurumsal Yaklaşım</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    2009 yılından bu yana Alaçatı ve İzmir&apos;in Ege kıyı bölgelerinde faaliyet gösteren <strong>Alaçatı Tenteci</strong>, 15 yılı aşkın deneyimiyle bölgenin köklü tente ve pergola markalarından biri haline gelmiştir. Kurumsal bir yaklaşımla yürütülen her proje; ön keşif, ölçüm, tasarım, üretim ve montaj aşamalarından oluşur. Müşteriye sunulan teklif şeffaf ve kapsamlıdır; gizli maliyet bulunmaz.
                  </p>
                </div>

                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Müşteri Memnuniyeti ve Referanslar</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Alaçatı, Çeşme, Ilıca, Ovacık, Dalyan ve Reisdere&apos;de tamamladığımız 500&apos;den fazla proje, müşteri memnuniyetinin en somut göstergesidir. Villa teraslarından otel havuz başlarına, kafe bahçelerinden ticari cephelere kadar geniş bir referans portföyüne sahibiz. Tamamlanan her proje, kalite ve özenin somut bir yansımasıdır.
                  </p>
                </div>

                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Keşif, Ölçüm ve Planlama Süreci</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Tüm projelerimiz ücretsiz yerinde keşifle başlar. Uzman ekibimiz mekânı değerlendirir, ölçüm alır ve ihtiyaca en uygun sistemi önerir. Keşif sonrası hazırlanan teklif, malzeme, işçilik ve montaj maliyetlerini ayrıntılı biçimde içerir. Onay sonrasında üretim ve montaj süreci hızla başlar; çoğu proje kısa sürede teslim edilir.
                  </p>
                </div>
              </div>
            </div>

            {/* ── BÖLÜM 3 ── */}
            <div className="mb-14">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-8 h-px bg-[#D4A853]"></span>
                <span className="text-[#D4A853] text-xs font-bold tracking-widest uppercase">Sektör Rehberi</span>
              </div>
              <h2 className="text-3xl font-black text-[#111827] mb-8 leading-tight">
                Alaçatı Tente Firmaları (2026)
              </h2>

              <div className="space-y-8">
                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Profesyonel Hizmet ve Uygulama</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Alaçatı&apos;da tente ve pergola hizmeti sunan firmalar arasında tercih yaparken dikkat edilmesi gereken en önemli unsur, firmanın bölgeye özgü iklim koşullarını ne ölçüde tanıdığıdır. Ege&apos;nin meltem rüzgarı ve yoğun güneş ışığı, malzeme seçimini ve montaj tekniğini doğrudan etkiler. <strong>Alaçatı Tenteci</strong>, bu koşulları yakından bilen, bölgede uzun yıllardır hizmet veren bir firma olarak öne çıkmaktadır.
                  </p>
                </div>

                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Teknoloji ve Modern Sistemler</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    2026 itibarıyla tente ve pergola sektöründe motorlu sistemler, akıllı ev entegrasyonu ve sensör teknolojileri giderek yaygınlaşmaktadır. Bioklimatik pergola lamellerinin uzaktan kumandayla kontrol edilmesi, yağmur sensörü sayesinde otomatik kapanma ve LED aydınlatma entegrasyonu artık standart özellikler arasına girmiştir. Bu teknolojilerin tamamını portföyümüzde sunuyoruz.
                  </p>
                </div>

                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Bölgeye Uygun Çözümler</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Alaçatı&apos;nın taş dokusu ve beyaz badanalı mimarisi, tente ve pergola seçiminde estetik uyumu ön plana çıkarır. Renk, malzeme ve form seçiminde mekânın genel karakteriyle uyumlu çözümler üretmek, uzun vadeli memnuniyetin temel koşuludur. Keşif sürecinde bu estetik değerlendirmeyi de müşterilerimizle birlikte yapıyoruz.
                  </p>
                </div>
              </div>
            </div>

            {/* ── BÖLÜM 4 ── */}
            <div className="mb-14">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-8 h-px bg-[#D4A853]"></span>
                <span className="text-[#D4A853] text-xs font-bold tracking-widest uppercase">Fiyat Rehberi</span>
              </div>
              <h2 className="text-3xl font-black text-[#111827] mb-8 leading-tight">
                Alaçatı Tente Fiyatları (2026 Güncel)
              </h2>

              <div className="space-y-8">
                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Fiyatı Belirleyen Unsurlar</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Tente ve pergola fiyatları; sistem türü, açıklık genişliği, kumaş veya lamel seçimi, motorlu/manuel tercih ve montaj koşullarına göre değişmektedir. Kasetli tente ile bioklimatik pergola arasında önemli fiyat farkları bulunabilir. Doğru fiyat bilgisine ulaşmanın en güvenilir yolu, yerinde keşif ve ölçüm sonrası hazırlanan kişiselleştirilmiş tekliftir.
                  </p>
                </div>

                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Maliyet ve Kalite Dengesi</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Düşük maliyetli sistemler kısa vadede cazip görünse de uzun vadede bakım ve yenileme maliyetleri toplam harcamayı artırabilir. <strong>Alaçatı Tenteci</strong> olarak kaliteli malzeme ve işçiliği rekabetçi fiyatlarla sunmayı ilke ediniyoruz. Şeffaf fiyatlandırma politikamız sayesinde teklif aşamasında tüm maliyetler açıkça paylaşılır.
                  </p>
                </div>

                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Keşif ve Teklif Süreci</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Fiyat bilgisi almak için herhangi bir ön ödeme veya taahhüt gerekmez. Bizi arayın ya da WhatsApp&apos;tan yazın; ekibimiz uygun bir zamanda yerinde keşif yapar ve kısa sürede detaylı teklif sunar. Keşif hizmetimiz tamamen ücretsizdir.
                  </p>
                </div>
              </div>
            </div>

            {/* ── BÖLÜM 5 ── */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="w-8 h-px bg-[#D4A853]"></span>
                <span className="text-[#D4A853] text-xs font-bold tracking-widest uppercase">Hizmet Bölgeleri</span>
              </div>
              <h2 className="text-3xl font-black text-[#111827] mb-8 leading-tight">
                Alaçatı&apos;da Hangi Alanlarda Hizmet Veriyoruz?
              </h2>

              <div className="space-y-8">
                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Konut ve Villa Uygulamaları</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Alaçatı ve çevresindeki villa, yazlık ev ve konut projelerinde teras, balkon ve bahçe alanları için kapsamlı çözümler sunuyoruz. Bioklimatik pergola ve kasetli tente, konut projelerinde en çok tercih edilen sistemler arasındadır. Mekânın mimarisiyle uyumlu renk ve malzeme seçimiyle estetik bütünlük sağlanır.
                  </p>
                </div>

                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Kafe, Restoran ve Ticari Alanlar</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Alaçatı&apos;nın canlı kafe ve restoran kültürü, açık alan kullanımını kritik bir rekabet unsuru haline getirmektedir. Şeffaf branda ve zip perde sistemleri, kış aylarında da teras kapasitesini koruyarak işletme gelirine doğrudan katkı sağlar. Ticari cepheler için T model tente, kurumsal görünümü destekleyen sağlam bir çözümdür.
                  </p>
                </div>

                <div className="border-l-2 border-[#D4A853] pl-6">
                  <h3 className="text-lg font-black text-[#111827] mb-3">Teras, Bahçe ve Açık Alan Çözümleri</h3>
                  <p className="text-[#555] text-sm leading-relaxed">
                    Çeşme, Ilıca, Ovacık, Dalyan ve Reisdere&apos;deki otel havuz başları, bahçe terasları ve açık etkinlik alanları için rollingroof pergola ve otomatik pergola sistemleri ideal çözümler sunar. Geniş açıklıkları kapatabilme kapasitesi ve motorlu kontrol kolaylığıyla bu sistemler, büyük ölçekli projelerde de güvenle uygulanmaktadır.
                  </p>
                </div>
              </div>
            </div>

          </article>

          {/* Sidebar */}
          <aside className="lg:col-span-1">
            <div className="sticky top-24 space-y-5">
              {/* Quick CTA */}
              <div className="bg-[#111827] p-7">
                <p className="text-[#D4A853] text-xs font-bold tracking-widest uppercase mb-3">Ücretsiz Keşif</p>
                <p className="text-white font-black text-lg leading-tight mb-4">
                  Projeniz için hemen teklif alın
                </p>
                <div className="space-y-3">
                  <a
                    href={PHONE_HREF}
                    className="flex items-center justify-center gap-2 bg-[#D4A853] text-[#111827] font-bold text-xs tracking-widest uppercase px-5 py-3.5 whitespace-nowrap cursor-pointer hover:bg-[#c49840] transition-colors w-full"
                  >
                    <i className="ri-phone-line"></i>
                    Hemen Ara
                  </a>
                  <a
                    href={WA_HREF}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="flex items-center justify-center gap-2 border border-white/20 text-white font-bold text-xs tracking-widest uppercase px-5 py-3.5 whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors w-full"
                  >
                    <i className="ri-whatsapp-line"></i>
                    WhatsApp&apos;tan Yaz
                  </a>
                </div>
              </div>

              {/* Hizmet listesi */}
              <div className="bg-white border border-[#E8E0D0] p-6">
                <p className="text-xs font-black tracking-widest uppercase text-[#111827] mb-4 pb-3 border-b border-[#E8E0D0]">Hizmetlerimiz</p>
                <ul className="space-y-2">
                  {[
                    ['Kasetli Tente', '/hizmetler/kasetli-tente'],
                    ['Körüklü Tente', '/hizmetler/koruklu-tente'],
                    ['Mafsallı Tente', '/hizmetler/mafsalli-tente'],
                    ['T Model Tente', '/hizmetler/t-model-tente'],
                    ['Win Tente', '/hizmetler/win-tente'],
                    ['Bioklimatik Pergola', '/hizmetler/bioklimatik-pergola'],
                    ['Otomatik Pergola', '/hizmetler/otomatik-pergola'],
                    ['Rollingroof Pergola', '/hizmetler/rollingroof-pergola'],
                    ['Şeffaf Branda', '/hizmetler/seffaf-branda'],
                    ['Şeffaf Stor Branda', '/hizmetler/seffaf-stor-branda'],
                    ['Zip Perde', '/hizmetler/zip-perde'],
                  ].map(([label, href]) => (
                    <li key={href}>
                      <a
                        href={href}
                        className="flex items-center gap-2 text-sm text-[#555] hover:text-[#D4A853] transition-colors cursor-pointer"
                      >
                        <span className="w-1 h-1 bg-[#D4A853] rounded-full flex-shrink-0"></span>
                        {label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Bölgeler */}
              <div className="bg-[#D4A853] p-6">
                <p className="text-xs font-black tracking-widest uppercase text-[#111827] mb-3">Hizmet Bölgeleri</p>
                <div className="flex flex-wrap gap-2">
                  {['Alaçatı', 'Çeşme', 'Ilıca', 'Ovacık', 'Dalyan', 'Reisdere'].map((b) => (
                    <span key={b} className="bg-[#111827] text-white text-xs font-semibold px-3 py-1.5">
                      {b}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </aside>

        </div>
      </div>
    </section>
  );
}
